<template>
    <div class="flex-page">
        <a-form class="ctrl" layout="inline">

            <!-- <a-form-item label="姓名">
                <a-input style="min-width: 200px" v-model="search.name" placeholder="请输入姓名关键词"></a-input>
            </a-form-item> -->
            <a-form-item label="所有人">
                <a-input style="min-width: 200px" v-model="search.suoyouren" placeholder="请输入所有人关键词"></a-input>
            </a-form-item>
            <a-form-item label="上传人">
                <a-input style="min-width: 200px" v-model="search.shangchuanren" placeholder="请输入上传人关键词"></a-input>
            </a-form-item>
            <a-form-item label="电话">
                <a-input style="min-width: 200px" v-model="search.mobile" placeholder="请输入电话关键词"></a-input>
            </a-form-item>
            <a-form-item label="记录名称">
                <a-input style="min-width: 200px" v-model="search.jiluName" placeholder="请输入记录名称键词"></a-input>
            </a-form-item>
            <a-form-item label="是否最大记录">
                <a-checkbox v-model="search.isMax" @change="doSearch"> </a-checkbox>
            </a-form-item>
            <a-form-item label="状态">
                <a-select style="width: 100px" v-model="search.status" @change="doSearch">
                    <a-select-option :value="-10">全部</a-select-option>
                    <a-select-option :value="0">审核中</a-select-option>
                    <a-select-option :value="1">已通过</a-select-option>
                    <a-select-option :value="-1">已拒绝</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="doSearch">搜索</a-button>
            </a-form-item>
        </a-form>

        <div class="article-page" style="overflow: auto;">
            <div class="list">
                <div class="statistics">共{{ amount }}条</div>
                <a-table bordered :dataSource="list" :columns="columns" :pagination="false" size="small"
                    :rowKey="(record) => record.id">
                    <template slot="weixin" slot-scope="text, record">
                        <div class="weixin-zhanshi">
                            <img class="weixin-headimg-radio" style="width: 40px;" :src="record.headimgurl" alt="">
                            {{ record.nickname }}
                        </div>
                    </template>
                    <template slot="tupian" slot-scope="text, record">
                        <img @click="openUrl(record.pic)" :src="record.pic" style="width: 80px;cursor:pointer;" alt="">
                    </template>
                    <template slot="chicun" slot-scope="text, record">
                        {{ record.size }}mm
                    </template>
                    <template slot="isMax" slot-scope="text, record">
                        <a-tag  v-if="record.is_max">MAX</a-tag>
                    </template>
                    
                    <template slot="status" slot-scope="text, record">
                        <a-tag color="orange" v-if="record.status == 0">审核中</a-tag>
                        <a-tag color="blue" v-if="record.status == 1">已通过</a-tag>
                        <a-tag color="red" v-if="record.status == -1">已拒绝 </a-tag>
                    </template>
                    <template slot="caozuo" slot-scope="text, record">
                        <a-button @click="toUrl('/chicun/logDetail?id=' + record.id)" size="small">
                            详情
                        </a-button>
                        <a-button style="margin-left: 5px" type="primary" @click="toUrl('/chicun/logEdit?id=' + record.id)" size="small">
                            编辑
                        </a-button>
                        <a-button v-if="record.status == 0" @click="showTongguo(record)" style="margin-left: 5px" type="primary" size="small">
                            通过
                        </a-button>

                        <a-popconfirm v-if="record.status == 0 || record.status == 1" title="确定要拒绝吗"
                            @confirm="changeStatus(record.id, -1)" okText="确定" cancelText="取消">
                            <a-button style="margin-left: 5px" type="danger"  size="small">
                                拒绝
                            </a-button>
                        </a-popconfirm>

                        <a-popconfirm  title="确定要删除吗"
                            @confirm="changeStatus(record.id, -2)" okText="确定" cancelText="取消">
                            <a-button style="margin-left: 5px" type="danger" size="small">
                                删除
                            </a-button>
                        </a-popconfirm>
                    </template>
                </a-table>
                <a-pagination @change="onChange" :total="amount" :defaultPageSize="50" :defaultCurrent="search.now_page"
                    showQuickJumper class="margin15" />
            </div>
        </div>
        <Tongguo v-if="shenhe.show" :id="shenhe.id" @tongguoCallBack="tongguoCallBack"/>
    </div>
</template>
  
<style lang='scss' scoped></style>
  
<script>
import moment from 'moment'
import Tongguo from './component/tongguo.vue'
export default {
    components: { Tongguo },
    data() {
        return {
            formItemLayout: {
                labelCol: {
                    span: 4,
                },
                wrapperCol: {
                    span: 20,
                },
            },
            columns: [
                {
                    title: "编号",
                    dataIndex: "id",
                    align: 'center'
                },
                {
                    title: "所有人",
                    align: 'center',
                    dataIndex: "suoyouren"
                },
                {
                    title: "上传人",
                    align: 'center',
                    dataIndex: "shangchuanren"
                },
                {
                    title: "微信",
                    align: 'center',
                    scopedSlots: {
                        customRender: "weixin",
                    }
                },
                {
                    title: "电话",
                    align: 'center',
                    dataIndex: "tel",
                },
                {
                    title: "记录名称",
                    align: 'center',
                    dataIndex: "name",
                },

                // {
                //     title: "头像",
                //     scopedSlots: {
                //         customRender: "weixin",
                //     },

                // },
                {
                    title: "记录图片",
                    align: 'center',
                    scopedSlots: {
                        customRender: "tupian",
                    }
                },
                {
                    title: "记录尺寸",
                    align: 'center',
                    scopedSlots: {
                        customRender: "chicun",
                    }
                },
                {
                    title: "是否最大记录",
                    align: 'center',
                    scopedSlots: {
                        customRender: "isMax",
                    }
                },

                {
                    title: "状态",
                    align: 'center',
                    scopedSlots: {
                        customRender: "status",
                    },
                },
                {
                    title: "操作",
                    align: 'center',
                    dataIndex: "caozuo",  
                    scopedSlots: {
                        customRender: "caozuo",
                    },
                },
            ],
            search: {
                name: "",
                mobile: "",
                jiluName: '',
                now_page: 1,
                status: -10,
                isMax: false,
                who: '',

            },
            amount: 0,
            pages: 1,
            list: [],
            shenhe: {
                show: false,
                id: null
            }
        };
    },
    watch: {

    },
    async created() {
        const query = this.$route.query
        if(query.who) {
            this.search.who = query.who
        }
        if(query.isMax) {
            this.search.isMax = true
        }
        this.getList();
    },
    mounted() {
    },
    methods: {
        moment,
        doSearch() {
            this.search.now_page = 1;
            this.getList();
        },
        async getList() {
            const r = await this.$axios.post("/chicun/getChicunList", this.search );
            this.list = r.data.list;
            this.amount = r.data.amount;
        },
        openUrl(url) {
            window.open(url)
        },
        onChange(e) {
            this.search.now_page = e;
            this.getList();
        },
        async changeStatus(id, status) {
            const r = await this.$axios.post("/chicun/changeLogStatus", {
                id: id,
                status: status,
            });
            if (r.status == 1) {
                // this.$message.success('操作成功')
                this.getList();
            } else {
                this.$message.error('操作失败...')
            }
        },
        toUrl(url) {
            this.$router.push(url)  
        },
        showTongguo(record) {
            this.shenhe.id = record.id
            this.shenhe.show = true
        },
        cancelTongguo() {
            this.shenhe.id = null
            this.shenhe.show = false
        },
        tongguoCallBack(e){
            this.cancelTongguo()
            if(e.status == 1) {
                this.getList();
            }
        }
    },
};
</script>
  
<style></style>
